import { Wallet } from 'lucide-react';

import { formatarData } from '@/lib/formato';
import { Dinheiro } from '@/ui/components/dinheiro';
import { EstadoVazio } from '@/ui/components/estado-vazio';
import { type DocumentoDetalhe } from '@fiscoai/contracts';

import { FORMA_PAGAMENTO } from './rotulos';

export function AbaPagamentos({ doc }: { doc: DocumentoDetalhe }) {
  if (doc.pagamentos.length === 0) {
    return (
      <EstadoVazio
        icone={<Wallet />}
        titulo="Sem pagamento informado"
        texto="O XML desta nota não traz forma de pagamento nem duplicatas."
      />
    );
  }
  return (
    <ul className="divide-y divide-borda rounded-cartao border border-borda">
      {doc.pagamentos.map((p, i) => (
        <li
          key={`${p.tipo}-${String(i)}`}
          className="flex items-center justify-between gap-3 px-4 py-3"
        >
          <div className="grid gap-0.5">
            <span className="font-medium">
              {p.tipo === 'DUPLICATA'
                ? `Duplicata ${p.numero ?? ''}`
                : (FORMA_PAGAMENTO[p.forma ?? ''] ?? 'Pagamento')}
            </span>
            {p.vencimento && (
              <span className="text-xs text-texto-suave">
                Vence em {formatarData(p.vencimento)}
              </span>
            )}
          </div>
          <Dinheiro valor={p.valor} className="font-medium" />
        </li>
      ))}
    </ul>
  );
}
